import { typedAction } from 'store/modules/base';

export interface FlashAlert {
  severity: 'success' | 'info' | 'warning' | 'error' | 'sessionExpired';
  message: string;
}

interface SnackBar {
  alerts: FlashAlert[];
}

const initialState: SnackBar = { alerts: [] };

export const addAlert = (alert: FlashAlert) => {
  return typedAction('snackBar/ADD', alert);
};

export const removeAlert = () => {
  return typedAction('snackBar/REMOVE');
};

export const resetSnackBar = () => {
  return typedAction('snackBar/RESET');
};

type SnackBarAction = ReturnType<typeof addAlert | typeof removeAlert | typeof resetSnackBar>;

export function snackBarReducer(state: SnackBar = initialState, action: SnackBarAction): SnackBar {
  switch (action.type) {
    case 'snackBar/ADD':
      return {
        ...state,
        alerts: [
          ...state.alerts,
          {
            ...action.payload,
          },
        ],
      };
    case 'snackBar/REMOVE':
      const updatedAlerts = [...state.alerts];
      updatedAlerts.shift();
      return {
        ...state,
        alerts: updatedAlerts,
      };
    case 'snackBar/RESET':
      return initialState;
    default:
      return state;
  }
}
